var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColpoSicuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9621 25.4565L18.5258 32.2974L8.92492 46.2947H0.705078L14.9621 25.4565ZM15.1758 29.1303L1.28015 8.54431H9.53633L20.375 25.4565L34.6747 46.2947H26.4549L15.1758 29.1303ZM17.5809 21.9237L25.8371 8.54004H34.0932L20.7085 28.9111L17.5809 21.9237Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5894 38.2916L83.4188 19.851C84.1905 18.8473 84.8201 17.741 85.2883 16.5641C85.733 15.4279 85.9553 14.3686 85.9564 13.3863V13.3317C85.9564 11.7498 85.4935 10.5227 84.5668 9.64938C83.64 8.77609 82.32 8.33998 80.6065 8.33998C78.9871 8.33998 77.6777 8.81777 76.6783 9.7723C75.6789 10.7268 75.0696 12.0769 74.8505 13.8224V13.8502H69.0977V13.8224C69.4258 11.5499 70.0939 9.60876 71.1029 7.999C72.0542 6.44375 73.4064 5.17176 75.0172 4.31664C76.6174 3.47114 78.4634 3.04785 80.5552 3.04785C82.9185 3.04785 84.9366 3.45296 86.6105 4.26212C88.2844 5.07128 89.5575 6.24921 90.4297 7.79484C91.3019 9.34047 91.738 11.2046 91.7391 13.3863V13.414C91.7391 14.8143 91.4484 16.2776 90.8658 17.8051C90.2587 19.3806 89.442 20.8664 88.4383 22.2239L76.9541 37.8299H91.9572V43.122H69.5894V38.2916Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1887 71.0327H48.624V37.4212L42.9834 40.8897V35.1348L48.6293 31.3701H54.194L54.1887 71.0327Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4139 84.9752C69.8743 84.9752 84.8394 70.01 84.8394 51.5496C84.8394 33.0892 69.8743 18.124 51.4139 18.124C32.9534 18.124 17.9883 33.0892 17.9883 51.5496C17.9883 70.01 32.9534 84.9752 51.4139 84.9752Z",
    stroke: "#FBB03B",
    strokeWidth: 5.60768,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.7959 49.7259C18.03 46.3247 18.9567 39.8568 23.2045 33.2649C29.9386 22.8174 40.2578 19.429 43.2325 18.5664",
    stroke: "white",
    strokeWidth: 0.529026,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.8555 18.223L49.3245 17.665",
    stroke: "white",
    strokeWidth: 0.529026,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1596 28.072H49.9422C49.381 28.072 48.9268 27.6178 48.9268 27.0566V2.01546C48.9268 1.45428 49.381 1 49.9422 1H53.1596C53.7208 1 54.1751 1.45428 54.1751 2.01546V27.0566C54.1751 27.6178 53.7208 28.072 53.1596 28.072Z",
    fill: "#FBB03B",
    stroke: "#FBB03B",
    strokeWidth: 0.21161,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1596 101H49.9422C49.381 101 48.9268 100.545 48.9268 99.9843V74.9432C48.9268 74.382 49.381 73.9277 49.9422 73.9277H53.1596C53.7208 73.9277 54.1751 74.382 54.1751 74.9432V99.9843C54.1751 100.545 53.7208 101 53.1596 101Z",
    fill: "#FBB03B",
    stroke: "#FBB03B",
    strokeWidth: 0.21161,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.584961 53.2934V50.076C0.584961 49.5148 1.03924 49.0605 1.60042 49.0605H26.6415C27.2027 49.0605 27.657 49.5148 27.657 50.076V53.2934C27.657 53.8546 27.2027 54.3088 26.6415 54.3088H1.60042C1.03924 54.3088 0.584961 53.8546 0.584961 53.2934Z",
    fill: "#FBB03B",
    stroke: "#FBB03B",
    strokeWidth: 0.21161,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3418 53.2963V50.0789C74.3418 49.5178 74.7961 49.0635 75.3573 49.0635H100.398C100.96 49.0635 101.414 49.5178 101.414 50.0789V53.2963C101.414 53.8575 100.96 54.3118 100.398 54.3118H75.3573C74.7961 54.3118 74.3418 53.8575 74.3418 53.2963Z",
    fill: "#FBB03B",
    stroke: "#FBB03B",
    strokeWidth: 0.21161,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2539 2.58398V15.5123",
    stroke: "white",
    strokeWidth: 0.317416,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2539 19.9326V21.3606",
    stroke: "white",
    strokeWidth: 0.317416,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2539 22.3564V26.6192",
    stroke: "white",
    strokeWidth: 0.317416,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.0577 8.54297C6.0577 8.54297 6.62422 12.1302 8.04158 15.5079C9.45894 18.8856 10.9469 22.8587 11.7827 24.0955L1.28613 8.54297H6.0577Z",
    fill: "#0071BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54.1887 31.3701C53.3336 33.3668 52.5223 35.5271 51.7943 37.8466C49.6042 44.8693 48.5224 52.1902 48.5876 59.5453C48.6283 61.0567 48.6283 37.4244 48.6283 37.4244L42.9834 40.8897V35.1348L48.6293 31.3701H54.1887Z",
    fill: "#0071BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M74.8537 13.8482C74.8195 12.2823 74.9392 8.61064 77.1112 6.03673C77.4447 5.63375 77.822 5.26819 78.2346 4.94752C80.7797 2.9754 83.7598 3.43182 83.7566 3.33348C83.7566 3.18811 77.6638 1.87015 73.5111 5.22115C72.8313 5.78553 72.2221 6.43008 71.694 7.13876C69.9335 9.38345 69.4493 11.8066 69.0977 13.8482H74.8537Z",
    fill: "#0071BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColpoSicuro);
export default __webpack_public_path__ + "static/media/colpoSicuro.f600bb7b30fa23e7189b7f30c582ad4d.svg";
export { ForwardRef as ReactComponent };